
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companyTag]",
      function () {
        return require("private-next-pages/[companyTag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companyTag]"])
      });
    }
  